module.exports = __webpack_public_path__ + "img/extstepblue.63c1396b.svg";